import './sentry';
import './posthog';

import { App } from 'app/App';
import { i18nInitPromise } from 'app/Providers/I18NextProvider';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';

import './tailwind.css';

const root = createRoot(document.getElementById('root') as HTMLElement);

i18nInitPromise.then(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
